module.exports = __webpack_public_path__ + "images/clipboard-list-check-light.svg";